/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @description 抖音订单接口
 */
import douYinStatusCheck from "./douYinStatusCheck";

export class DouYinOrderApi {
  constructor(
    public douYinStatusCheck: (
      showId: string,

      success?: ({
        data,
        ext,
        state,
        errors,
      }: {
        data: number;
        ext: ObjectMap;
        state: "SUCCESS" | "FAIL" | "EXCEPTION";
        errors?: Array<string>;
      }) => any,
      fail?: (error: string) => any
    ) => void
  ) {}
}

export default {
  douYinStatusCheck,
} as DouYinOrderApi;
